var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"barcode",staticClass:"barcode d-none d-md-inline-block iphone-x-hide"})}
var staticRenderFns = []

export { render, staticRenderFns }